import { GitMerge } from "@phosphor-icons/react";

const OUTPUTS = [
  "Personalized nutrition, training, and supplementation.",
  "FDA-approved medications, peptides, and hormone optimization — when the data calls for it.",
  "Continuous re-tuning as new signals arrive — labs, wearables, biomarkers.",
];

/**
 * Output panel for the Matrix Engine — right column on dark background showing
 * how the fused data turns into clinical protocols.
 */
export default function MatrixOutputPanel() {
  return (
    <div
      data-testid="matrix-output"
      className="h-full p-7 md:p-8 bg-foreground text-background border-2 border-foreground rounded-2xl shadow-xl flex flex-col"
    >
      <div
        className="font-mono text-[0.6rem] uppercase tracking-[0.22em] mb-4"
        style={{ color: "hsl(220 18% 72%)" }}
      >
        Output · Clinical Protocols
      </div>
      <div className="flex items-center gap-3 mb-6">
        <GitMerge size={28} weight="duotone" className="text-accent flex-shrink-0" />
        <h3
          className="font-display text-2xl md:text-3xl font-semibold leading-tight"
          style={{ color: "hsl(38 38% 95%)" }}
        >
          Generates an evidence-based analysis so your physician can make an informed decision.
        </h3>
      </div>
      <ul className="space-y-3 text-base md:text-lg text-background/85 leading-relaxed flex-1">
        {OUTPUTS.map((line) => (
          <li key={line} className="flex items-start gap-2">
            <span className="text-accent mt-1">→</span>
            {line}
          </li>
        ))}
      </ul>
      <p
        className="mt-6 text-sm leading-relaxed italic"
        style={{ color: "hsl(38 38% 85% / 0.75)" }}
      >
        Always titrated alongside your physician — never instead of one.
      </p>
    </div>
  );
}
